module.exports = __webpack_public_path__ + "img/why-check-img1.02c639c2.png";